'use client'

import { usePathname } from 'next/navigation'
import Script from 'next/script'
import { env } from 'utils/env'

import { isOnMobiDomain } from './isOnMobiDomain'
import { GTMAssetsState } from './RootLayout.types'

export const GtmHead = () => {
	const pathname = usePathname()

	let hideGTMAssets: GTMAssetsState
	if (pathname.startsWith('/generator/preview')) {
		hideGTMAssets = GTMAssetsState.HIDE
	} else if (pathname.startsWith('/qr/[id]/[mode]')) {
		hideGTMAssets = GTMAssetsState.PARTIAL
	} else {
		hideGTMAssets = GTMAssetsState.SHOW
	}

	return (
		<>
			{hideGTMAssets !== GTMAssetsState.HIDE ? (
				<>
					<link
						rel="preconnect"
						href="https://www.googletagmanager.com"
					/>
					<link rel="preconnect" href="https://plausible.io" />
					<link rel="dns-prefetch" href={env.BASE_URL} />
					<link
						rel="dns-prefetch"
						href="https://fonts.googleapis.com"
					/>
					<link rel="dns-prefetch" href="https://fonts.gstatic.com" />
					<link
						rel="dns-prefetch"
						href="https://region1.google-analytics.com"
					/>
					<link
						rel="dns-prefetch"
						href="https://www.google-analytics.com"
					/>
					<link
						rel="dns-prefetch"
						href="https://stats.g.doubleclick.net"
					/>
					<link rel="dns-prefetch" href="https://unpkg.com" />
					<link rel="dns-prefetch" href="https://bat.bing.com" />
				</>
			) : null}

			<link rel="dns-prefetch" href="https://cdnjs.cloudflare.com" />

			{hideGTMAssets === GTMAssetsState.SHOW ? (
				<link rel="dns-prefetch" href="https://plausible.io" />
			) : null}

			{hideGTMAssets === GTMAssetsState.SHOW && (
				<Script
					async
					src={`/api/analytics?v=${process.env.IMAGE_TAG || 'dev'}`}
					strategy="afterInteractive"
				/>
			)}

			{hideGTMAssets !== GTMAssetsState.HIDE && isOnMobiDomain && (
				<Script
					async
					// v= busts the browser's 1-year immutable cache on this script each deploy
					src={`/api/mobi-analytics?v=${process.env.IMAGE_TAG || 'dev'}`}
					strategy="afterInteractive"
				/>
			)}

			{hideGTMAssets !== GTMAssetsState.HIDE && (
				<>
					<link rel="preload" href="/api/load-fonts" as="style" />
					<link rel="stylesheet" href="/api/load-fonts" />
				</>
			)}
		</>
	)
}
